import {
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CONFIRM_EMAIL_SUCCESS,
  CONFIRM_EMAIL_FAIL,
  LOGOUT,
  SET_MESSAGE,
  SEND_AAD_INVITE_SUCCESS,
  SEND_AAD_INVITE_FAIL
} from "./types";

import AuthService from "../services/auth.service";
import { getAuth } from "../common/Helpers";

export const register = (objUser) => (dispatch) => {
  return AuthService.register(objUser).then(
    (response) => {
      dispatch({
        type: CREATE_USER_SUCCESS,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message,
      });

      return Promise.resolve();
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: CREATE_USER_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const register2 = (sendAADInvite, objUser, username, clientId) => async (dispatch) => {
  return await AuthService.register(objUser).then(async (response) => {
    if (sendAADInvite === true) {
      await AuthService.sendAADInvitation(username, clientId).then((responseInvitation) => {
        if (responseInvitation.data.succeeded === true ) {
          dispatch({ type: CREATE_USER_SUCCESS });
          dispatch({ type: SET_MESSAGE, payload: response.data.message });
        }
        else {
          dispatch({ type: CREATE_USER_FAIL });
          dispatch({ type: SET_MESSAGE, payload: response.data.message });
        }
      }).catch((errorInvitation) => {
        const message = errorInvitation.response?.data?.message || errorInvitation.message || errorInvitation.toString();

        dispatch({ type: CREATE_USER_FAIL });
        dispatch({ type: SET_MESSAGE, payload: message });
      });
    }
    else {
      dispatch({ type: CREATE_USER_SUCCESS });
      dispatch({ type: SET_MESSAGE, payload: response.data.message });
    }

    return Promise.resolve();
  },
  (error) => {
    const message = error.response?.data?.message || error.message || error.toString();

    dispatch({ type: CREATE_USER_FAIL });
    dispatch({ type: SET_MESSAGE, payload: message });

    return Promise.reject(error);
  });
};

export const login = (username, password, domain, rememberme, loginMode, languaje, recaptcha_token) => (dispatch) => {
  return AuthService.login(username, password, domain, rememberme, loginMode, languaje, recaptcha_token).then((data) => {
      if (data.data.data === "2FR") {
        return Promise.resolve(data.data);
      }
      else {
        return Promise.resolve(data.data);
      }
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const loginAAD = (username, password, domain, rememberme, loginMode, languaje, recaptcha_token, msalToken) => (dispatch) => {
  return AuthService.loginAAD(username, password, domain, rememberme, loginMode, languaje, recaptcha_token, msalToken).then((data) => {
      if (data.data.data === "2FR") {
        return Promise.resolve(data.data);
      }
      else {
        return Promise.resolve(data.data);
      }
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const resendTwoFactor = (username, password, domain, rememberme, loginMode, languaje, codeType) => (dispatch) => {
  return AuthService.resendTwoFactor(username, password, domain, rememberme, loginMode, languaje, codeType).then((data) => {
      dispatch({
        type: SET_MESSAGE,
        payload: data.data,
      });
      return Promise.resolve();
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const loginTwoFactor = (username, password, domain, rememberme, loginMode, languaje, twoFactorCode) => (dispatch) => {
  return AuthService.loginTwoFactor(username, password, domain, rememberme, loginMode, languaje, twoFactorCode).then((data) => {
      return Promise.resolve(data.data);
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(message);
    }
  );
};

export const forgotPassword = (domain, username, email, confirmationEmail, languaje) => (dispatch) => {
  return AuthService.forgotPassword(domain, username, email, confirmationEmail, languaje).then((response) => {
      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
        payload: response.data.message
      });

      return Promise.resolve();
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: FORGOT_PASSWORD_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const confirmEmail = (token, email, languaje) => (dispatch) => {
  return AuthService.confirmEmail(token, email, languaje).then((response) => {
      dispatch({
        type: CONFIRM_EMAIL_SUCCESS,
        payload: response.data.message
      });

      return Promise.resolve();
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: CONFIRM_EMAIL_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const resetPassword = (forgotPassModel) => (dispatch) => {
  return AuthService.resetPassword(forgotPassModel).then((response) => {
      dispatch({
        type: CHANGE_PASSWORD_SUCCESS,
        payload: response.data.message
      });

      return Promise.resolve();
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: CHANGE_PASSWORD_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const changePassword = (userId, password, newPassword) => (dispatch) => {
  return AuthService.changePassword(userId, password, newPassword).then((response) => {
      dispatch({
        type: CHANGE_PASSWORD_SUCCESS,
        payload: response.data.message
      });

      return Promise.resolve(response);
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();

      dispatch({
        type: CHANGE_PASSWORD_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject(error);
    }
  );
};

export const sendAADInvitation = (userName, clientId) => (dispatch) => {
  return AuthService.sendAADInvitation(userName, clientId).then((response) => {
      dispatch({ type: SEND_AAD_INVITE_SUCCESS, payload: response.data.message });

      return Promise.resolve(response);
    },
    (error) => {
      const message = error.response?.data?.message || error.message || error.toString();
      dispatch({ type: SEND_AAD_INVITE_FAIL, });
      dispatch({ type: SET_MESSAGE, payload: message, });

      return Promise.reject(error);
    }
  );
};

export const refreshSession = () => () => {
  return AuthService.refreshSession().then(
    (response) => Promise.resolve(response.data),
    (error) => Promise.reject(error)
  );
};

export const logout = (url, flag, userName) => (dispatch) => {
  dispatch({ type: LOGOUT });
  return AuthService.logout(url, flag, userName);
};

export const getDomains = (email) => (dispatch) => {
  return AuthService.getDomains(email).then((serviceResponse) => {
    const _reponse = serviceResponse.data;
    return Promise.resolve(_reponse.data);
  },
  (error) => {
    const message = error.response?.data?.message || error.message || error.toString();

    dispatch({
      type: LOGIN_FAIL,
    });

    dispatch({
      type: SET_MESSAGE,
      payload: message,
    });

    return Promise.reject(error);
  });
};

export const getDomainsFPw = () => (dispatch) => {
  return AuthService.getDomainsFPw().then((serviceResponse) => {
    const _reponse = serviceResponse.data;
    return Promise.resolve(_reponse.data);
  },
  (error) => {
    const message = error.response?.data?.message || error.message || error.toString();

    dispatch({
      type: LOGIN_FAIL,
    });

    dispatch({
      type: SET_MESSAGE,
      payload: message,
    });

    return Promise.reject(error);
  });
};

export const authGetClient = () => {
  const user = JSON.parse(getAuth());

  if (user) {
    if (user.clientId !== "00000000-0000-0000-0000-000000000000" && user.clientId !== null && user.clientId !== undefined && user.clientId !== "") {
      return user.clientId;
    }
    else {
      return null;
    }
  }
};

export const authGetUserName = () => {
  const user = JSON.parse(getAuth());
  if (user) {
    return user.username;
  }
};

export const authGetPictureProfile = () => {
  const user = JSON.parse(getAuth());
  if (user) {
    return user.profileUrl;
  }
};
